import { render } from "./Milestone.vue?vue&type=template&id=34b7ed79"
import script from "./Milestone.vue?vue&type=script&lang=js"
export * from "./Milestone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__